import {triggerScrollDepth,getScrolledDepth} from '../analytics';


export const options = {
    root: document.querySelector(".home-page"),
    rootMargin: '0px',
    threshold: 0.9
  }

export  const observerCallback=(entries, observer)=>{
  const visited={};

  return (entries, observer)=>{
  
    entries.forEach((entry) => {
      let dataModuleId = entry.target.getAttributeNode("data-module-id").value;
        if(entry.isIntersecting && !visited[dataModuleId]) {
          visited[dataModuleId]='visited';
          triggerScrollDepth();
        }
      });
  }
}

export const createTargetElement =(el)=> document.querySelector(el);



// WEBPACK FOOTER //
// ./services/utility/observer/index.js